module.exports = __webpack_public_path__ + "img/banner.e8329094.webp";